var _excluded = ["className", "children"],
    _excluded2 = ["className", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Pipeline from '../Pipeline';
import Button, { StyledButton } from '../Button/BaseButton';
var brandColors = {
  baseColor: '#800080',
  hoverColor: '#5a005a',
  activeColor: '#a600a6',
  foregroundColor: '#FFFFFF'
};
var MAStyledButton = /*#__PURE__*/styled(StyledButton).withConfig({
  displayName: "AlgoDeploy__MAStyledButton",
  componentId: "sc-157ggf2-0"
})(["&{transition:all 0.15s ease;}&:hover{box-shadow:0px 2px 4px rgba(0,0,0,0.2);}&& > svg.r-ff-icon{height:", ";width:", ";margin-right:0.5rem;margin-bottom:-2px;}"], function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
}, function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
});
var StyledButtonSolid = /*#__PURE__*/styled(MAStyledButton).withConfig({
  displayName: "AlgoDeploy__StyledButtonSolid",
  componentId: "sc-157ggf2-1"
})(["&{color:", ";background:", ";}&:hover{background-color:", ";}&:active{background-color:", ";}"], brandColors.foregroundColor, brandColors.baseColor, brandColors.hoverColor, brandColors.activeColor);
var StyledButtonOutline = /*#__PURE__*/styled(MAStyledButton).withConfig({
  displayName: "AlgoDeploy__StyledButtonOutline",
  componentId: "sc-157ggf2-2"
})(["&{color:#333;background:", ";border:1px solid #ccc;}&:hover{background-color:#f3f2f2;}&:active{background-color:#e4e4e4;}"], brandColors.foregroundColor);

var ButtonBody = function ButtonBody(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var MyAlgoButtonSolid = function MyAlgoButtonSolid(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledButtonSolid, _extends({
    className: 'algo-btn-solid'
  }, props), /*#__PURE__*/React.createElement(ButtonBody, {
    children: children,
    size: props.size
  }));
};

var MyAlgoButtonOutline = function MyAlgoButtonOutline(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React.createElement(StyledButtonOutline, _extends({
    className: 'algo-btn-outline'
  }, props), /*#__PURE__*/React.createElement(ButtonBody, {
    children: children,
    size: props.size
  }));
};

var defaultProps = _objectSpread(_objectSpread({}, Button.defaultProps), {}, {
  width: 'auto',
  borderRadius: 1,
  boxShadow: 1
});

MyAlgoButtonSolid.defaultProps = defaultProps;
MyAlgoButtonOutline.defaultProps = defaultProps;
var MyAlgoButton;
MyAlgoButton = MyAlgoButtonSolid;
MyAlgoButton.Solid = MyAlgoButtonSolid;
MyAlgoButton.Outline = MyAlgoButtonOutline;
MyAlgoButton.propTypes = _objectSpread({}, Button.propTypes);
MyAlgoButton.displayName = 'MyAlgoButton';

var AlgoDeploy = function AlgoDeploy(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MyAlgoButton, {
    className: "AlgoDeploy",
    onClick: function onClick() {
      Pipeline.deployTeal(props.tealProgram, props.tealClear, props.bytesInts, props.appArgs, props.onComplete).then(function (data) {
        if (typeof data !== 'undefined') {
          if (props.returnTo !== undefined) {
            var object = {};
            object[props.returnTo] = data;
            props.context.setState(object);
          }

          if (typeof props.onChange === 'function') {
            props.onChange(data);
          }
        }
      });
    }
  }, "Deploy"));
};

export default AlgoDeploy;